import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import 'leaflet/dist/leaflet.css';
import { Amplify } from 'aws-amplify';
import { ThemeProvider } from '@mui/material/styles';
import theme from './theme';
import { LanguageProvider } from './LanguageContext';

// Configure AWS Cognito
Amplify.configure({
  Auth: {
    Cognito: {
      userPoolId: 'eu-north-1_ToXYoHPEC',                   // user pool id
      userPoolClientId: '68s96lpmmpq7v2gqnu3568s9bq',    //  App Client ID
      region: 'eu-north-1'                                  //  region
    }
  }
});

console.log("1. Amplify.configure has executed in index.js");


const root = ReactDOM.createRoot(document.getElementById('root'));
// ThemeProvider wraps everything so MUI's modal layer sits above the app's own
// z-index scale — see theme.js for why this is set centrally rather than on the
// individual Dialog and Select components.
root.render(
  <React.StrictMode>
    <ThemeProvider theme={theme}>
      <LanguageProvider>
        <App />
      </LanguageProvider>
    </ThemeProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
